import Button from '@/components/Button';
import { WildcardEntity } from '@/graphql/generated/graphql';
import { HeartIcon } from '@heroicons/react/24/outline';
import { useAnnouncementStore } from '../../../store/announcementStore';

export const AnnouncementPreview = ({ wildcard }: { wildcard: WildcardEntity }) => {
  const { page } = useAnnouncementStore();

  return (
    <div className="relative h-[428px] w-[335px] overflow-hidden rounded-2xl border-[5px] border-white bg-[#D3E4F5]">
      <div className="absolute left-1/2 top-[25px] z-10 flex size-32 -translate-x-1/2 items-center justify-center overflow-hidden rounded-full">
        <img
          src={wildcard.attributes?.image?.data?.attributes?.url}
          alt="logo"
          className={`h-[125px] w-[125px] rounded-full object-cover object-center`}
        />
      </div>
      <div
        className=" absolute -bottom-[100px] left-1/2 size-[440px] -translate-x-1/2 rounded-t-full bg-white"
        style={{
          background: 'radial-gradient(50% 50% at 50% 50%, #D0E2F5 0%, #FFF 100%)',
        }}>
        <div className=" px-[80px] pt-[100px] text-center text-sh-xxs">
          <p className="mt-2 text-center text-sh-12-18 md:text-start">{wildcard.attributes?.description}</p>
          <Button className="mt-sh-15">
            <HeartIcon className="h-5 w-5" />
            {page?.preview?.like}
          </Button>
        </div>
      </div>
    </div>
  );
};
